<template>
  <modal
    elem-id="modal_pdv_checkout"
    size="xlarge"
    :close-label="t('Fechar')"
    :title="t('Checkout')"
    :show="isVisible"
    @close="closeModal"
    @dismiss="closeModal"
  >
    <template v-if="isVisible && state.orderId !== undefined">
      <div data-testid="pdv-checkout-modal">
        <PDVCheckoutForm
          :order-id="state.orderId"
          host="modal"
          @done="handleDone" />
      </div>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { reactive, ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';
import PDVCheckoutForm from './PDVCheckoutForm.vue';

interface OpenModalPayload {
  orderId?: number | string;
}

const { t } = useI18n();

const isVisible = ref(false);
const state = reactive<OpenModalPayload>({
  orderId: undefined,
});

function openModal(data?: OpenModalPayload): void {
  log('PDVCheckoutModal', 'openModal', 'Opening modal', data);
  state.orderId = data?.orderId;
  isVisible.value = true;
}

function closeModal(): void {
  log('PDVCheckoutModal', 'closeModal', 'Closing modal');
  isVisible.value = false;
  state.orderId = undefined;
}

function handleDone(): void {
  eventBus.emit('modal.pdv-checkout.closed-saved');
  closeModal();
}

onMounted(() => {
  eventBus.on('modal.pdv-checkout.open', openModal);
  eventBus.on('modal.pdv-checkout.close', closeModal);
});

onBeforeUnmount(() => {
  eventBus.off('modal.pdv-checkout.open', openModal);
  eventBus.off('modal.pdv-checkout.close', closeModal);
});
</script>
